import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-customInfo-list',
  templateUrl: './customInfo-list.component.html',
  styleUrls: ['./customInfo-list.component.scss']
})
export class CustomInfoListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {   
    this.touch;
  }
 
  @Output() editCustomInfoEmmitter = new EventEmitter();
  @Output() deleteCustomInfoEmmitter = new EventEmitter();

  @Input() touch;

  editCustomInfo(CustomInfo: any){
    this.editCustomInfoEmmitter.emit(CustomInfo);
  }

  deleteCustomInfo(CustomInfo: any){
    this.deleteCustomInfoEmmitter.emit(CustomInfo);
  }


}
